import { embedDashboard } from '@superset-ui/embedded-sdk';
import axios from 'axios';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { Container, Row, Col, Button, Card } from 'reactstrap';
import React, { useEffect } from 'react';
import { Storage } from 'react-jhipster';

async function getSuperSetToken(dashboardId) {
  const rsToken = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');

  const rs_header = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + rsToken,
    },
  };

  await axios.get('api/super-set/token?dashboardId=' + dashboardId, rs_header).then(dt => {
    if (dt.data['dashboardId']) {
      embedDashboard({
        id: dt.data['dashboardId'],
        supersetDomain: dt.data['superSetUrl'],
        mountPoint: document.getElementById('superset-container') as HTMLElement,
        fetchGuestToken: () => {
          return dt.data['token'];
        },
        dashboardUiConfig: { hideTitle: true },
        iframeSandboxExtras: ['allow-same-origin', 'allow-scripts', 'allow-forms', 'allow-popups', 'allow-popups-to-escape-sandbox'],
      });
    }
  });

  const iframe = document.querySelector('iframe');
  if (iframe) {
    iframe.style.width = '100%';
    iframe.style.minHeight = '60vw';
  }
}

const ReportingDashboard = () => {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      getSuperSetToken(id);
    }
  }, [id]);

  return (
    <Container fluid className="py-3">
      <Row className="mb-3">
        <Col>
          <Card
            style={{
              width: '100%',
              padding: '14px',
              boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
            }}
          >
            <Row>
              <Col>
                <div id="superset-container"></div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ReportingDashboard;
